<template>
  <div class="personnelList">
    <div class="header_tool">
      <div class="tool">
        <div
          class="item"
          @click="
            queryInfo.status = '0'
            search()
          "
        >
          <i class="iconfont icon-user1"></i>
          在职<span>{{ statusNum[0] }}</span
          >人
        </div>
        <div
          class="item"
          @click="
            queryInfo.status = '3'
            search()
          "
        >
          <i class="iconfont icon-user1"></i>
          正式员工<span>{{ statusNum[1] }}</span
          >人
        </div>
        <div class="item" @click="$router.push({ name: 'outsourcingList' })">
          <i class="iconfont icon-user1"></i>
          外线员工<span>{{ statusNum[4] }}</span
          >人
        </div>
      </div>
      <div class="tool">
        <div
          class="item"
          @click="
            queryInfo.status = '2'
            search()
          "
        >
          <i class="iconfont icon-user1"></i>
          试用期<span>{{ statusNum[2] }}</span
          >人
        </div>
        <div
          class="item"
          @click="
            queryInfo.status = '1'
            search()
          "
        >
          <i class="iconfont icon-user1"></i>
          岗前培训期<span>{{ statusNum[3] }}</span
          >人
        </div>
      </div>
    </div>
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true" :model="queryInfo">
          <el-form-item label="姓名">
            <el-input v-model="queryInfo.pername"></el-input>
          </el-form-item>
          <el-form-item label="籍贯">
            <el-select v-model="queryInfo.province" clearable>
              <el-option v-for="item in provinceList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryInfo.status">
              <el-option label="所有" value="0"></el-option>
              <el-option label="正式员工" value="3"></el-option>
              <el-option label="试用期" value="2"></el-option>
              <el-option label="试岗期" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="queryInfo.sex">
              <el-option label="所有" value=""></el-option>
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="dep_id" class="dep_id">
            <el-select v-model="queryInfo.dep_id" placeholder="请选择" ref="selectTree" clearable>
              <el-option :key="queryInfo.dep_id" :value="queryInfo.dep_id" :label="queryInfo.dep_id" hidden> </el-option>
              <el-tree :data="datalist" :props="defaultProps" @node-click="handleClickNode" :default-expand-all="true" node-key="id"></el-tree>
            </el-select>
          </el-form-item>
          <el-form-item class="indayst">
            <el-select v-model="queryInfo.type">
              <el-option label="入职时间" value="入职时间"></el-option>
              <el-option label="到期时间" value="到期时间"></el-option>
              <el-option label="生日时间" value="生日时间"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template v-if="queryInfo.type !== '生日时间'">
              <el-date-picker v-model="queryInfo.indayst" prefix-icon=" " align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
              <span class="middle">到</span>
              <el-date-picker v-model="queryInfo.indayet" prefix-icon=" " align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
            </template>
            <template v-else>
              <template>
                <el-select v-model="queryInfo.indayst" placeholder="请选择" multiple collapse-tags class="indayst">
                  <el-option v-for="item in option" :label="item.label" :value="item.value" :key="item.label"> </el-option>
                </el-select>
              </template>
            </template>
          </el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
          <el-form-item style="margin-right: 0">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="$router.push({ name: 'addPersonnel' })">添加员工</el-button>
            <el-button size="small" @click="exportDialog = true" plain class="searchBtn">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="pername" label="姓名" width="70" align="center"> </el-table-column>
          <el-table-column prop="dep_id" label="部门" align="center"> </el-table-column>
          <el-table-column prop="roles" label="职位" align="center"> </el-table-column>
          <el-table-column prop="sex" label="性别" align="center"> </el-table-column>
          <el-table-column prop="province" label="籍贯" align="center"> </el-table-column>
          <el-table-column prop="birthday" label="生日" align="center"> </el-table-column>
          <el-table-column label="年龄" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.birthday | getAge }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="contact" width="158" label="手机号" align="center"> </el-table-column>
          <el-table-column prop="cardid" width="200" label="身份证号" align="center"> </el-table-column>
          <el-table-column prop="inday" label="入职日期" align="center"> </el-table-column>
          <el-table-column prop="endpactday" label="合同到期" align="center"> </el-table-column>
          <el-table-column label="司龄" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.inday | dateSubMonth }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <div style="cursor: pointer; color: #fb5c00" @click="show(scope.row)">
                <span v-if="scope.row.stu == 1">试岗期</span>
                <span v-else-if="scope.row.stu == 2">试用期</span>
                <span v-else-if="scope.row.stu == 3">正式员工</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="158">
            <template slot-scope="scope">
              <div class="table_btns">
                <el-button size="mini" @click="$router.push({ name: 'personnelDetail', params: { id: scope.row.id } })">查看</el-button>
                <el-button @click="$router.push({ name: 'editPersonnel', params: { id: scope.row.id, index: scope.$index } })" size="mini">编辑</el-button>
                <el-button size="mini" @click="del(scope.row.id)" class="warning">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-size="queryInfo.pageSize" layout="total, prev, pager, next,jumper" :total="total" background> </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog class="resignDialog" ref="resignDialog" :modal="false" title="更改员工状态" :visible.sync="resignDialog" width="280px">
      <el-form ref="resign" :rules="rules" :model="resignData" label-width="52px">
        <el-form-item label="状态" prop="stu">
          <el-select v-model="resignData.stu" clearable>
            <el-option label="试岗期" :value="1"></el-option>
            <el-option label="试用期" :value="2"></el-option>
            <el-option label="正式员工" :value="3"></el-option>
            <el-option label="离职" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" prop="setday">
          <el-date-picker v-model="resignData.setday" prefix-icon=" " align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
        </el-form-item>
        <el-form-item label="原因" prop="cause">
          <el-input type="textarea" :disabled="resignData.stu > 0 ? true : false" v-model="resignData.cause"></el-input>
        </el-form-item>
        <el-form-item>
          <input type="text" v-model="resignData.id" hidden />
          <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="change()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog class="exportDialog" ref="exportDialog" :modal="false" title="导出条件" :visible.sync="exportDialog" width="804px" @close="exportField = []">
      <el-checkbox-group class="exportField" v-model="exportField" size="mini">
        <div class="item1">
          <el-checkbox label="pername" border>姓名</el-checkbox>
          <el-checkbox label="sex" border>性别</el-checkbox>
          <el-checkbox label="age" border>年龄</el-checkbox>
          <el-checkbox label="province" border>籍贯</el-checkbox>
          <el-checkbox label="address" border>户籍地址</el-checkbox>
          <el-checkbox label="contact" border>手机号码</el-checkbox>
          <el-checkbox label="marrage" border>婚姻状态</el-checkbox>
          <el-checkbox label="organ" border>政治面貌</el-checkbox>
          <el-checkbox label="nation" border>民族</el-checkbox>
        </div>
        <div class="item2">
          <el-checkbox label="school" border>学校</el-checkbox>
          <el-checkbox label="manjor" border>专业</el-checkbox>
          <el-checkbox label="edu" border>学历</el-checkbox>
          <el-checkbox label="birthday" border>生日</el-checkbox>
          <el-checkbox label="cardid" border>身份证号</el-checkbox>
          <el-checkbox label="moreinfo" border>备注</el-checkbox>
        </div>
        <div class="item1">
          <el-checkbox label="dep_id" border>部门</el-checkbox>
          <el-checkbox label="roles" border>岗位</el-checkbox>
          <el-checkbox label="stu" border>状态</el-checkbox>
          <el-checkbox label="entryTime" border>司龄</el-checkbox>
          <el-checkbox label="inday" border>入职日期</el-checkbox>
          <el-checkbox label="prepactday" border>合同日期</el-checkbox>
          <el-checkbox label="source" border>信息来源</el-checkbox>
          <el-checkbox label="msper" border>面试人</el-checkbox>
        </div>
        <div class="btn_box">
          <el-button class="lightBlueBtn exporBtn" type="primary" size="small" @click="exportPersonnel()">提交</el-button>
          <el-button size="small" plain class="exporBtn" @click="checkAll()">全选</el-button>
        </div>
      </el-checkbox-group>
    </el-dialog>
  </div>
</template>

<script>
  import { getDepList } from '@/api/common.js'
  import { changeStatus, delPersonnel, exportPersonnel, getPersonnel } from '@/api/personnelList'
  import pageCacheMix from '@/mixins/pageCacheMix'
  import { dateSubMonth, getAge } from '@/util'
  import download from 'downloadjs'
  export default {
    name: 'personnelList',
    mixins: [pageCacheMix],
    data() {
      return {
        queryInfo: {
          // 姓名
          pername: '',
          sex: '',
          // 籍贯
          province: '',
          indayst: '',
          indayet: '',
          endpactdayet: '',
          endpactdayst: '',
          dep_id: '',
          type: '入职时间',
          // 状态
          status: '',
          // 当前页
          pageNum: 1,
          // 每页数量
          pageSize: 12,
        },
        // 下拉框选项1-12月
        option: [
          { label: '1月', value: '1' },
          { label: '2月', value: '2' },
          { label: '3月', value: '3' },
          { label: '4月', value: '4' },
          { label: '5月', value: '5' },
          { label: '6月', value: '6' },
          { label: '7月', value: '7' },
          { label: '8月', value: '8' },
          { label: '9月', value: '9' },
          { label: '10月', value: '10' },
          { label: '11月', value: '11' },
          { label: '12月', value: '12' },
        ],

        // 籍贯列表
        provinceList: ['北京', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '上海', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '重庆', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '台湾', '香港', '澳门'],
        exportDialog: false,
        statusNum: [0, 0, 0, 0, 0],
        tableData: [],
        total: 0,
        resignDialog: false,
        resignData: {
          stu: 0,
          setday: '',
          cause: '',
          id: '',
        },
        rules: {
          stu: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
          setday: [{ required: true, message: '时间不能为空', trigger: 'blur' }],
          cause: [
            {
              validator: (rule, value, callback) => {
                if (this.resignData.stu === 0 && value === '') {
                  callback(new Error('请输入离职原因'))
                } else {
                  callback()
                }
              },
              trigger: 'blur',
            },
          ],
        },
        exportField: [],
        isCheckAll: false,
        datalist: [],
        defaultProps: {
          children: 'children',
          label: 'name',
        },
      }
    },
    async created() {
      this.getPersonnel()
      let { data } = await getDepList()
      this.datalist = data
    },
    methods: {
      //节点点击事件
      handleClickNode(data) {
        this.queryInfo.dep_id = data.name
        // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
        this.$refs.selectTree.blur()
      },
      // 获取人员列表
      async getPersonnel() {
        if (this.queryInfo.type === '生日时间') {
          this.queryInfo.indayst = this.queryInfo.indayst.join(',')
        }
        let { plist, statusNum } = await getPersonnel(this.queryInfo)
        if (this.queryInfo.type === '生日时间' && this.queryInfo.indayst) {
          this.queryInfo.indayst = this.queryInfo.indayst.split(',')
        }
        this.tableData = plist.data
        this.total = plist.total
        this.statusNum = statusNum
      },
      // 监听当前页码的变化
      handleCurrentChange(newpagenum) {
        this.queryInfo.pageNum = newpagenum
        this.getPersonnel()
      },
      // 搜索
      search() {
        // 页码恢复第一页
        this.queryInfo.pageNum = 1
        this.getPersonnel()
      },
      // 导出
      async exportPersonnel() {
        let data = this.queryInfo
        let res = await exportPersonnel({ ...data, exportField: this.exportField })
        if (res.status !== 200) {
          return this.$message.error(res.msg)
        }
        this.$message.success('导出成功')
        download(process.env.VUE_APP_UPLOAD_URL + res.data)
        // const aLink = document.createElement('a')
        // aLink.href = process.env.VUE_APP_UPLOAD_URL + res.data
        // console.log(aLink)
        // document.body.appendChild(aLink)
        // aLink.click()
        // document.body.removeChild(aLink)
      },
      // 删除人员
      async del(id) {
        if (!id) return this.$message.error('请选择要删除的数据')
        const res = await this.$confirm('您确定删除该用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).catch((err) => err)
        if (res !== 'confirm') return this.$message.info('取消成功')
        let response = await delPersonnel({ id })
        if (response.status !== 200) {
          this.$message.error('删除失败')
        } else {
          this.$message.success('删除成功')
          // 删除成功后刷新页面
          this.getPersonnel()
        }
      },
      // 显示修改状态弹窗
      show(data) {
        let { stu, id } = data
        this.resignData.stu = stu
        this.resignData.id = id
        this.resignDialog = true
      },
      async change() {
        this.$refs['resign'].validate(async (valid) => {
          if (!valid) return
          let res = {}
          if (this.id !== '') {
            let data = this.resignData
            res = await changeStatus(data)
          } else {
            return this.$message.error('id不能为空')
          }
          if (res.status !== 200) return this.$message.error('提交失败')
          this.$message.success('提交成功')
          this.$refs['resign'].resetFields()
          this.resignDialog = false
          return this.getPersonnel()
        })
      },
      checkAll() {
        if (!this.isCheckAll) {
          this.isCheckAll = !this.isCheckAll
          this.exportField = ['pername', 'sex', 'age', 'province', 'contact', 'marrage', 'organ', 'nation', 'school', 'manjor', 'edu', 'birthday', 'cardid', 'moreinfo', 'dep_id', 'roles', 'stu', 'entryTime', 'inday', 'prepactday', 'source', 'msper']
        } else {
          this.exportField = []
          this.isCheckAll = !this.isCheckAll
        }
      },
    },
    // 局部更新编辑后数据
    activated() {
      let editData = sessionStorage.getItem('editData') || null
      let editDataIndex = sessionStorage.getItem('editDataIndex') || ''
      if (editData && editDataIndex !== '') {
        editData = JSON.parse(editData)
        // 更新修改数据
        this.$set(this.tableData, editDataIndex, editData)
        //删除缓存数据
        sessionStorage.removeItem('editDataIndex')
        sessionStorage.removeItem('editData')
      } else {
        //删除缓存数据
        sessionStorage.removeItem('editDataIndex')
        sessionStorage.removeItem('editData')
        return
      }
    },
    filters: {
      // 计算年龄
      getAge(age) {
        return getAge(age)
      },
      // 计算入职时间
      dateSubMonth(date) {
        return dateSubMonth(date)
      },
    },
    // 监听queryInfo.type值的变化
    watch: {
      'queryInfo.type': function (val) {
        if (val === '生日时间') {
          this.queryInfo.indayst = ''
          this.queryInfo.indayet = ''
        } else {
          this.queryInfo.indayst = ''
          this.queryInfo.indayet = ''
        }
      },
    },
  }
</script>

<style lang="less">
  .personnelList {
    .header_tool {
      display: flex;
      margin-top: 10px;
      margin-bottom: 30px;
      justify-content: space-between;
      .tool {
        flex: 60%;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        display: flex;
        transition: 0.3s;
        margin-right: 25px;
        box-shadow: 0px 0px 4px 0px rgba(80, 80, 80, 0.3);
        &:last-child {
          flex: 40%;
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            color: #666666;
            padding: 15px 70px 8px 85px;
          }
        }
        &:first-child {
          .item {
            position: relative;
            padding-right: 80px;
            padding-left: 60px;
            &:nth-child(2)::after {
              position: absolute;
              content: '';
              width: 1px;
              height: 47px;
              background-color: #dddddd;
              top: 28px;
              right: 0;
            }
          }
        }
        &:hover {
          border-color: #67a5d6;
        }
        &:last-of-type {
          margin-right: 0;
          .item {
            span {
              color: #015293;
            }
          }
        }
        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          color: #666666;
          padding: 15px 116px 8px 105px;
          cursor: pointer;
          i {
            margin-right: 10px;
          }
          &:first-of-type {
            position: relative;
            &::after {
              position: absolute;
              content: '';
              width: 1px;
              height: 47px;
              background-color: #dddddd;
              top: 28px;
              right: 0;
            }
          }
          span {
            font-family: Square721 Cn BT;
            font-size: 50px;
            color: #ff6f20;
            padding: 0 10px;
            transform: scale(0.95);
            &:hover {
              transform: scale(1);
            }
          }
        }
      }
    }
    .tableBox {
      border-top: 1px solid #dcdfe6;
      .tool_bar {
        padding-top: 28px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;
          .indayst {
            .el-input__inner {
              width: 150px !important;
            }
          }
          &.dep_id {
            .el-input__inner {
              width: 120px;
            }
          }
          &.indayst {
            margin-right: -5px;
            .el-input__inner {
              border: 0;
            }
          }
          .el-input__inner,
          .el-date-editor.el-input {
            width: 100px;
            height: 32px;
          }
          .el-date-editor.el-input {
            width: 120px;
            .el-input__inner {
              width: 120px;
            }
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
          &:last-of-type {
            float: right;
          }
        }
      }
      .el-table {
        min-height: 585px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .resignDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 0;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 15px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 178px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 178px;
    }
    .searchBtn {
      width: 112px;
    }
  }
  .exportDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-top: 20px;
    }
    .exportField {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .btn_box {
        display: flex;
        width: 100%;
        flex-direction: row-reverse;
        .exporBtn {
          width: 112px;
          margin-left: 20px;
        }
      }
      .item1 {
        width: 100%;
        display: flex;
        .el-checkbox {
          flex: 1/8;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .item2 {
        width: 100%;
        display: flex;
        .el-checkbox {
          flex: 1/9.223;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .el-checkbox {
        background-color: #f7f7f7;
        margin-right: 0;
        margin-bottom: 20px;
        border-radius: 16px;
        .el-checkbox__label {
          padding-left: 7px;
        }
      }
      .el-checkbox.is-bordered {
        border-color: #f7f7f7;
      }
      .el-checkbox.is-bordered.is-checked {
        border-color: #409eff !important;
      }
      .el-checkbox__inner {
        display: none;
      }
    }
  }
</style>
